<template>
    <el-dropdown class="mr20 fan-jian-change" @command="switchLang">
      <span class="el-dropdown-link">
      {{getCurrentLangLabel(language)}}
      </span>
      <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item,index) in languageListComp"  :command="item.command" :key="index">{{ item.label }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import { mapGetters,mapActions } from 'vuex'
import {languageList,getCurrentLangLabel} from '@/utils/common.js'
import {getSystemRole} from '@/utils/auth.js'
export default {
  data(){
    return {
      isSystemRole: getSystemRole(),
    }
  },
  computed: {
    languageListComp() {
      if(this.isSystemRole) {
        return languageList
      }else{
        return languageList.filter(item => item.command !== 'en')
      }
    },
    ...mapGetters([
      'language'
    ])
  },
  methods:{
    getCurrentLangLabel:getCurrentLangLabel,
    switchLang(language){
      let value = language
      this.$i18n.locale = value;
      this.setLanguage(value)
      this.$emit('changeFanjian')
      //window.location.reload()
    },
    ...mapActions({
      setLanguage:'setLanguage'
    })
  }
}
</script>

<style lang="scss" scoped>
.fan-jian-change {
  border: 1px solid #121212;
  color: #121212;
  border-radius: 4px;
  padding: 0 5px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 14px;
  line-height: 20px;
}
</style>